import { faTachometerAlt, faBullhorn, faUserPlus, faHandHoldingUsd, faBriefcase, faCalendarAlt, faMusic, faTasks, faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HomeIcon from "assets/icons/home-icon";
import ImageUrl from "components/app/image-url/ImageUrl";
import ImageUrl1 from "components/app/image-url/ImageUrl1";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Skeleton } from "components/ui/skeleton";
import { Plus, Settings } from "lucide-react";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppLog } from "services";
import { setIsDialogCreateShopOpen, setIsHidden } from "store/header";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, RouteUrl } from "utils";
import { Service } from "utils/services";

export default function AccountDetailLeftSideContent() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const accountId = searchParams.get("id");
  const navigate = useNavigate();
  const { isHidden } = useAppSelector((state) => state.header);
  const { accountProfile, loadingAccountProfile } = useAppSelector((state) => state.layout);
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const navLink = [
    {
      name: "Dashboard",
      url: RouteUrl.accountDashboard,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-cyan-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faTachometerAlt} />
        </div>
      ),
    },
    {
      name: "Music Libraries",
      url: RouteUrl.musicLibraries,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-lime-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faMusic} />
        </div>
      ),
    },
    {
      name: "Campaigns",
      url: RouteUrl.campaigns,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faBullhorn} />
        </div>
      ),
    },

    // {
    //   name: "Testing",
    //   url: RouteUrl.testing,
    //   icon: (
    //     <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
    //       <FontAwesomeIcon icon={faBullhorn} />
    //     </div>
    //   ),
    // },

    {
      name: "Leads",
      url: RouteUrl.leads,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-red-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faUserPlus} />
        </div>
      ),
    },
    {
      name: "Opportunities",
      url: RouteUrl.opportunities,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faHandHoldingUsd} />
        </div>
      ),
    },
    {
      name: "Jobs",
      url: RouteUrl.jobs,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-gray-700 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faBriefcase} />
        </div>
      ),
    },
    {
      name: "Events",
      url: RouteUrl.events,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faCalendarAlt} />
        </div>
      ),
    },
    {
      name: "Projects",
      url: RouteUrl.projects,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-purple-600 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faTasks} />
        </div>
      ),
    },
    {
      name: "Tools",
      url: RouteUrl.toolsAccount,
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <FontAwesomeIcon icon={faScrewdriverWrench} />
        </div>
      ),
    },
  ];

  function handleClickNavLink(link: string) {
    dispatch(setIsHidden(!isHidden));
    if (location.pathname !== link) {
      navigate(`${link}?id=${accountId}`);
    }
  }

  return (
    <>
      <div className={`transition-all duration-300 ease-in-out overflow-hidden  ${isHidden ? "w-[70px]" : " w-0"} lg:w-[310px] border-r-2`}>
        <div className="p-2 lg:p-4 space-y-2 flex flex-col justify-between h-[calc(100vh-90px)]">
          <ScrollArea className="h-full">
            {/* {loadingInitAccount ? (
              <>
                <Skeleton className="w-full h-[60px] rounded-xl" />
              </>
            ) : (
              <div className="flex items-center w-full h-[60px] border p-2 rounded-xl">
                <ImageUrl src={Service.userAuth?.picture} className="w-[40px] h-[40px] rounded-full" alt="" />
                <div className=" flex-col items-start justify-start ms-2 hidden lg:block">
                  <h1 className="font-semibold line-clamp-1 text-start">{Service.userAuth?.name}</h1>
                  <p className="text-sm text-muted-foreground line-clamp-1 text-start">{Service.userAuth?.bio}</p>
                </div>
              </div>
            )} */}

            <div className="space-y-2">
              {navLink.map((link, index) => {
                return (
                  <button
                    key={index}
                    onClick={() => handleClickNavLink(link.url)}
                    className={`p-2 rounded-xl cursor-pointer w-full  ${
                      location.pathname === link.url ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                    }`}
                  >
                    <ul>
                      <li className="flex items-center space-x-2">
                        {link.icon}
                        <p className=" text-sm font-medium hidden lg:block">{link.name}</p>
                      </li>
                    </ul>
                  </button>
                );
              })}
            </div>

            <ScrollBar orientation="vertical" />
          </ScrollArea>

          <div className="space-y-2">
            {loadingAccountProfile ? (
              <Skeleton className="w-full h-16 rounded-xl" />
            ) : (
              <>
                {accountProfile ? (
                  <button
                    onClick={() => navigate(`${RouteUrl.businessSuite}?id=${accountProfile?.shop_id}`)}
                    className="p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900"
                  >
                    <div className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                      <ImageUrl1 src={accountProfile?.thumbnail} className="w-8 h-8 rounded-full" />
                      <div className="hidden lg:flex flex-col items-start justify-start ms-2">
                        <h1 className="font-semibold line-clamp-1 text-start">{accountProfile?.shop_name}</h1>
                        <p className="text-sm text-muted-foreground line-clamp-1 text-start">{accountProfile?.description}</p>
                      </div>
                    </div>
                  </button>
                ) : (
                  <button
                    onClick={() => dispatch(setIsDialogCreateShopOpen(true))}
                    className="p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900"
                  >
                    <div className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                      <Plus />
                      <p className="text-md hidden lg:block">{t("Create your shop")}</p>
                    </div>
                  </button>
                )}
              </>
            )}

            <button onClick={() => navigate(RouteUrl.ProfileDetail)} className="p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
              <div className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                <Settings />
                <p className="text-md hidden lg:block">Setting & Account</p>
              </div>
            </button>

            <button onClick={() => navigate("/")} className="p-2 rounded-xl cursor-pointer w-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
              <div className="flex items-center justify-center lg:justify-start space-x-0 lg:space-x-2">
                <HomeIcon />
                <p className="hidden lg:block text-md">Home</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
